import { render, staticRenderFns } from "./AdminSchedulesList.vue?vue&type=template&id=2922f673&scoped=true"
import script from "./AdminSchedulesList.vue?vue&type=script&lang=js"
export * from "./AdminSchedulesList.vue?vue&type=script&lang=js"
import style0 from "./AdminSchedulesList.vue?vue&type=style&index=0&id=2922f673&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2922f673",
  null
  
)

export default component.exports